import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M11.2972 13.5472C11.0542 13.4707 6.22646 11.3347 4.51046 6.42975C3.77471 4.3245 4.23296 3.01725 4.74746 2.29275C5.45321 1.29825 6.33371 1.125 7.03121 1.125C8.99396 1.125 9.39071 2.25225 9.39071 3C9.39071 3.86775 8.93771 4.875 7.60946 4.875C6.88646 4.875 6.38696 4.32825 6.38696 3.75M18.7035 13.5472C18.9465 13.4707 23.7742 11.3347 25.4902 6.42975C26.226 4.3245 25.7677 3.01725 25.2532 2.29275C24.5467 1.29825 23.6662 1.125 22.9687 1.125C21.006 1.125 20.6092 2.25225 20.6092 3C20.6092 3.86775 21.0622 4.875 22.3905 4.875C23.1135 4.875 23.613 4.32825 23.613 3.75",
                stroke: "#FF9D33",
                "stroke-miterlimit": "10"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5182 21.9968H14.4818L14.25 17.25H15.75L15.5182 21.9968Z",
                fill: "#FF9D33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.375 24.375V23.436L15 21.4327L17.625 23.436V24.375H12.375Z",
                fill: "#FCAC38"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 21.9045L17.25 23.6212V24H12.75V23.6212L15 21.9045ZM15 20.961L12 23.25V24.75H18V23.25L15 20.961Z",
                fill: "#FF9D33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 17.625C10.9192 17.625 9.42221 9.56025 9.37646 1.875H20.6235C20.5777 9.56025 19.0807 17.625 15 17.625Z",
                fill: "#FCAC38"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 17.625C10.9192 17.625 9.42221 9.56025 9.37646 1.875H20.6235C20.5777 9.56025 19.0807 17.625 15 17.625Z",
                fill: "#FCAC38"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.2448 2.25C20.1532 9.33675 18.7425 17.25 15 17.25C11.2575 17.25 9.84675 9.33675 9.75525 2.25H20.2448ZM21 1.5H9C9 6.77475 9.78075 18 15 18C20.2192 18 21 6.77475 21 1.5Z",
                fill: "#FF9D33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.125 24.375H19.875V28.875H10.125V24.375Z",
                fill: "#B08159"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.5 24.75V28.5H10.5V24.75H19.5ZM20.25 24H9.75V29.25H20.25V24Z",
                fill: "#704E34"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 26.25H18V27H12V26.25Z",
                fill: "#FCAC38"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.75 5.25H9.75L9 4.5H15.75V5.25ZM18 4.5V5.25H20.25L21 4.5H18Z",
                fill: "#FF9D33"
            })
        ]
    }));
};
export default Icon;
